import { RoleEditForm } from './EditRole';
import { hasUserPermission } from '../utils/userPermissions';
import { faUserShield } from '@fortawesome/free-solid-svg-icons';
import CreateRecordModal from '../components/CreateRecordModal';
import PermissionGate from '../components/PermissionGate';
import React, { useState } from 'react';
import { Alert, Button } from '@themesberg/react-bootstrap';
import { PageRoleTable } from '../components/Tables';
import { RoleForm } from './CreateRole';

export default () => {
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [isCreating, setIsCreating] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [isUpdating, setIsUpdating] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [creationMessage, setCreationMessage] = useState('');

  const closeCreateModal = () => {
    if (!isCreating) setShowCreateModal(false);
  };

  const handleRoleCreated = (result) => {
    setShowCreateModal(false);
    setCreationMessage(result.message || 'Role created successfully.');
    setRefreshKey(value => value + 1);
  };

  const openEditModal = id => {
    if (!hasUserPermission('roles', 'edit')) return;
    setCreationMessage('');
    setEditingId(id);
  };

  const closeEditModal = () => {
    if (!isUpdating) setEditingId(null);
  };

  const handleUpdated = result => {
    setEditingId(null);
    setCreationMessage(result.message || 'Role updated successfully.');
    setRefreshKey(value => value + 1);
  };

  return (
    <>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-3">
        <div className="my-auto">
          <h2 className="page-breadcrumb">Roles</h2>
        </div>
        <PermissionGate module="roles" action="add"><Button
          variant="primary"
          className="btn-quote-blue d-inline-flex align-items-center py-2 px-3 box-shedow-none outline-none"
          onClick={() => { setCreationMessage(''); setShowCreateModal(true); }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-plus-circle me-1"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line></svg>
          Create Role
        </Button></PermissionGate>
      </div>

      {creationMessage && (
        <Alert variant="success" dismissible onClose={() => setCreationMessage('')}>
          {creationMessage}
        </Alert>
      )}

      <div className="my-auto">
        <PageRoleTable refreshKey={refreshKey} onEditRole={openEditModal} />
      </div>

      <CreateRecordModal
        show={showCreateModal}
        onHide={closeCreateModal}
        isSubmitting={isCreating}
        titleId="create-role-title"
        title="Create Role"
        description="Add a role to identify users in your team."
        icon={faUserShield}
      >
        {showCreateModal && (
          <RoleForm
            onSuccess={handleRoleCreated}
            onCancel={closeCreateModal}
            onSubmittingChange={setIsCreating}
          />
        )}
      </CreateRecordModal>

      <CreateRecordModal
        show={editingId !== null}
        onHide={closeEditModal}
        isSubmitting={isUpdating}
        titleId="edit-role-title"
        title="Edit Role"
        description="Update role details."
        icon={faUserShield}
      >
        {editingId !== null && (
          <RoleEditForm key={editingId} roleId={editingId}
            onSuccess={handleUpdated} onCancel={closeEditModal} onSubmittingChange={setIsUpdating} />
        )}
      </CreateRecordModal>
    </>
  );
};
